import { useQueryClient } from "@tanstack/react-query";
import { ComponentType } from "../../../constants";
import { useOptimisticUpdateMutation } from "../../../hooks/useOptimisticUpdateMutation";
import ComponentsService from "../../../services/ComponentsService";
import { COMPONENT_TEMPLATES_LIST_QUERY_KEY } from "../ComponentTemplateDialog";
import {
  IPaginatedListOfComponentTemplateDto,
  PaginatedListOfComponentTemplateBriefDto,
} from "@growth-machine-llc/stridist-api-client";
import { COMPONENT_TEMPLATES_LIBRARY_QUERY_KEY } from "../../component-templates-library/ComponentTemplateLibrary";

// Use to delete component template from the sidebar
export const useDeleteComponentTemplateMutation = () => {
  const queryClient = useQueryClient();

  return useOptimisticUpdateMutation({
    successToastMessage: "Template removed",
    queryKey: [COMPONENT_TEMPLATES_LIST_QUERY_KEY],
    exactQueryKey: false,
    mutationFn: ComponentsService.removeComponentTemplate,
    optimisticUpdater: {
      updateFn: (
        oldData: PaginatedListOfComponentTemplateBriefDto,
        variables,
        _,
      ) => {
        const updatedData = PaginatedListOfComponentTemplateBriefDto.fromJS({
          ...oldData,
          items: oldData.items.filter((item) => item.id !== variables),
        });

        return updatedData;
      },
    },
    options: {
      onSuccess(_, id) {
        queryClient.setQueryData(
          [COMPONENT_TEMPLATES_LIBRARY_QUERY_KEY],
          (oldData: IPaginatedListOfComponentTemplateDto) => {
            return {
              ...oldData,
              items: oldData?.items?.filter((item) => item.id !== id),
            };
          },
        );
      },
    },
  });
};
